import React, { useState, useEffect, useRef } from "react";
import { WebService } from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import StaticListComponent from "../../Services/StaticListComponent";
import "../Static/Static.css";
import ActionButton from "../../Services/ActionButton";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import SnackbarComponent from "../../Services/SnackbarComponent";
import AddEditProjectRoleMaster from "./AddEditProjectRoleMaster";
import "./Static.css";
import { ActionPermission, PageInfo } from "../PageInfo";
import "./Master.css";
import "../Static/Static.css";
import { extend, findWhere, map } from "underscore";
import { NoRecordTemplate } from "../../Services/TableComponent";
import { StandardConst } from "../../Services/StandardConst";
import Button from "react-bootstrap/Button";
import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
import { useLocation } from "react-router-dom";

const ProjectRoleMaster = () => {
  const { state } = useLocation();
  PageInfo({ pageTitle: "Project Designations" });

  const [permission, SetPermission] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList??[]);
  useEffect(() => {
    SetPermission({
      ManageAdd: ActionPermission("Project Role - Add"),
    ManageEdit: ActionPermission("Project Role - Edit"),
    ManageDelete: ActionPermission("Project Role - Delete"),
    });
  }, [permissionList]);

  const ref = useRef();
  const refSnackbar = useRef();
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);

  const fetchProjectRoleMaster = async () => {
    await Promise.all([
      WebService({
        endPoint: `CommonUtility/fetchAll/static_project_roles?CompanyId=${StandardConst.YesNo.Yes}`,
        dispatch,
      })
        .then((c) =>
          map(c, (m) =>
            extend(m, {
              ParentProjectRole: findWhere(c, { ProjectRoleId: m.ParentId })
                ?.DisplayDescription,
            })
          )
        )
        .then(setRecords),
      dispatch(ConfigurationflowStatusUpdate()),
    ]);
  };

  const onDelete = async (ProjectRoleId) => {
    await WebService({
      endPoint: `CommonUtility/static_project_roles?ProjectRoleId=${ProjectRoleId}`,
      method: "DELETE",
      dispatch,
    }).then((_) => fetchProjectRoleMaster());
    refSnackbar.current.setOpenSnackBar();
  };

  const renderAfterCalled = useRef(false);
  const addEditModalRef = useRef();
  useEffect(() => {
    if (!renderAfterCalled.current) {
        fetchProjectRoleMaster();
    }
    renderAfterCalled.current = true;
  }, []);
  const columns = [
    {
      Text: "Project Designation",
      Value: "DisplayDescription",
    },
    {
      Text: "Reports To",
      Value: "ParentProjectRole",
    },
    {
      Searchable: false,
      Text: "Action",
      cssClass: "text-center td-width-100",
     // isVisiable: permission.ManageEdit || permission.ManageDelete,
     // Template: (
      render: (dr)=>(
        <>
          <ActionButton
            onClick={() =>
              fnEdit(dr.ProjectRoleId)
            }
           // disabled={!permission.ManageEdit}
            IconName="Edit"
            id="btnProjectRoleMasterEdit"
          />

          <ActionButton
            onClick={(e) =>
              ref.current.confirmAlert(
                "Delete", //Confirm button text
                "Are You Sure", // Text if Alert
                "Do you want to delete " + MasterPageName, // Message of Alert
                dr.ProjectRoleId // Endpoint to hit for delete
              )
            }
           // disabled={!permission.ManageDelete}
            IconName="Delete"
            id="btnProjectRoleMasterDelete"
          />
        </>
      ),
    },
  ];
  const [bData, setBData] = React.useState([
    {
      title: "Company",
      hrefLink: "#",
    },
    {
      title: "Project Designations",
      hrefLink: "#",
    },
  ]);
  const MasterPageName = "Project Designations";
  const confirmMessage = MasterPageName + " Deleted successfully";
  const AddButtonText = "Project Designation";



  const fnEdit = async (id=0) => await addEditModalRef.current.openModal(id);
  return (
    <>
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
      <StaticListComponent
        columns={columns}
        records={records}
        bData={bData}
        MasterPageName={MasterPageName}
        AddButtonText={AddButtonText}
        noRecordCss="p-0"
        BackBtnReturnPath={(state?.SourcePageName === StandardConst.ReturnPagePaths.ActionCenter) ? StandardConst.ReturnPagePaths.ActionCenter : ""}
        noRecordFound={
          <NoRecordTemplate
          headerValue={StandardConst.ProjectDesignationheaderValueNoResults}
          subHeaderValue={StandardConst.ProjectDesignationHeaderRole}
          imageUrl={StandardConst.imageNoRecordsFound}          
          actionButton={
            <>
              {true && (
                <Button variant="outline-primary" onClick={() => fnEdit(0)} id={`no_record_add_${AddButtonText}`}>
                  Add {AddButtonText}
                </Button>
              )}
            </>
          }
          />
        }
        onAddEvent={() => fnEdit()}
        IsAddButtonVisible={true}
        isSearchRequired={true}
        allowSerialNo={true}
      ></StaticListComponent>
      <AddEditProjectRoleMaster
        callBackEvent={() => fetchProjectRoleMaster()}
        ref={addEditModalRef}
      ></AddEditProjectRoleMaster>
    </>
  );
};
export default ProjectRoleMaster;
